import assessmentTypes from "@/view/constants/assessmentTypes";

const { QUIZ, WRITE_PROMPT, POWER_WORDS_ACTIVITY } = assessmentTypes;

/**
 * Returns the href object for a specific attachment
 * @param {string} attachment
 * @param {boolean} isStudent
 * @param {string} pathname
 * @param {object} query
 * @returns {object} href object used for the router
 */

const getActivityPanelNavigationHref = ({
  attachment,
  isElaSkillsQuiz,
  isStudent,
  pathname,
  query,
}) => {
  const { data } = attachment;
  const assessmentType = data.assessment_type;
  const activityTypeUrlFormatted = isElaSkillsQuiz
    ? "quizOverview"
    : data?.assessment_type?.toLowerCase();

  const href = {
    pathname,
    query: {
      ...query,
      activityPanel: activityTypeUrlFormatted,
    },
  };

  if (assessmentType === QUIZ.type) {
    href.query.quizId = attachment.id;
    // Initial routing for students is handled in the QuizContainer
    if (!isStudent && !isElaSkillsQuiz) {
      href.query.question = 1;
    }
  } else if (assessmentType === WRITE_PROMPT.type) {
    href.query.writePromptId = attachment.id;
  } else if (assessmentType === POWER_WORDS_ACTIVITY.type) {
    href.query.powerWordsActivityId = attachment.id;
  }

  return href;
};

export default getActivityPanelNavigationHref;
